import moment from "moment";
import toast from "react-hot-toast";

const getDurationBetweenTwoDates = (startDateTime: any, endDateTime: any) => {
  return moment.duration(moment(endDateTime).diff(startDateTime));
};

export const getLastModifiedDate = (timestamp: any) => {
  const duration = getDurationBetweenTwoDates(timestamp, new Date());
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const formatedDuration = days
    ? `${days}d`
    : hours
    ? `${hours}h`
    : minutes
    ? `${minutes}m`
    : seconds
    ? `${seconds}s`
    : "";
  return formatedDuration;
};

export const copyTextToClipboard = async (tx: string) => {
  navigator.clipboard.writeText(tx);
  toast.success("Copied");
};

export const performSwitchNetwork = async (networkId: string) => {
  try {
    let ethereum = (window as any).ethereum;
    if (ethereum) {
      const hexChainId = Number(networkId).toString(16);
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: `0x${hexChainId}` }],
      });
    }
  } catch (err: any) {
    toast.error(err?.message);
  }
};

export const addTokenToMetaMask = async (tokenChainData: any) => {
  try {
    const ethereum = (window as any).ethereum;
    if (ethereum) {
      await ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenChainData.address,
            symbol: tokenChainData.symbol,
            decimals: tokenChainData.decimals,
            image: tokenChainData.logoURI,
          },
        },
      });
    }
  } catch (e) {
    console.error("Add token", e);
  }
};

export const addClassToBodyTag = (action: boolean) => {
  if (action) {
    document.body.classList.add("Fdialog-open");
  } else {
    document.body.classList.remove("Fdialog-open");
  }
};

export const isTransactionHashValid = (addr: string) => {
  return /^0x([A-Fa-f0-9]{64})$/.test(addr);
};

export const convertExponentialToNumber = (n: any) => {
  var sign = +n < 0 ? "-" : "",
    toStr = n.toString();
  if (!/e/i.test(toStr)) {
    return n;
  }
  var [lead, decimal, pow] = n
    .toString()
    .replace(/^-/, "")
    .replace(/^([0-9]+)(e.*)/, "$1.$2")
    .split(/e|\./);
  return +pow < 0
    ? sign +
        "0." +
        "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
        lead +
        decimal
    : sign +
        lead +
        (+pow >= decimal.length
          ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
          : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
};
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};
export const openTransactionOnExplorer = (
  blockExplorerUrl: any,
  hash: any,
  name: any
) => {
  if (name == "algorand" || name == "cudos network") {
    return blockExplorerUrl + "/" + hash;
  }
  return blockExplorerUrl + "/tx/" + hash;
};

export const MIN_LENGTH = (length: String) => {
  return `Minimum ${length} symbols`;
};

export const MAX_LENGTH = (length: String) => {
  return `Maximum ${length} symbols`;
};

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
export const TELEGRAM_HANDLE_REGEX = /^@[A-Za-z0-9_]{5,32}(\s+)?$/;
